import React, { useState, useRef } from "react";
import styles from "./style.module.css";
import ProductCard from "../../../components/ProductCard";
import LoadContent from "../../../components/LoadContent/index";
import langData from "../../../lang/data";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import UseOutSideClick from "../../../helpers/UseOutSideClick";

const CategoryBlock = ({ myData, showMoreBtn, url, showRecordSelector = false, isEmptyState = false }) => {
  const { currentLanguage } = useSelector(({ main }) => main);
  const [productsPerPage, setProductsPerPage] = useState(8);
  const [showRecordDropdown, setShowRecordDropdown] = useState(false);
  const recordDropdownRef = useRef(null);
  UseOutSideClick(recordDropdownRef, () => setShowRecordDropdown(false));

  const displayedProducts = myData?.slice(0, productsPerPage) ?? [];
  const useTwoSections = showRecordSelector && productsPerPage === 16;

  const emptyText = { hy: "Այս կատեգորիայում ապրանքներ չկան", ru: "В этой категории нет товаров", en: "No products in this category" };

  return (
    <div>
      {isEmptyState ? (
        <div className={styles.emptyState}>{emptyText[currentLanguage] ?? emptyText.hy}</div>
      ) : !myData?.length ? (
        <LoadContent containerClassName={styles.loadContent} />
      ) : (
        <>
          {showRecordSelector && (
            <div className={styles.recordSelector}>
              <span>{langData?.product?.record?.[currentLanguage]}:</span>
              <div
                ref={recordDropdownRef}
                className={styles.recordSelect}
                onClick={() => setShowRecordDropdown(!showRecordDropdown)}>
                <span>{productsPerPage}</span>
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.0293 5L4.99991 0.97083L9.02908 4.94145" stroke="#282828" />
                </svg>
                {showRecordDropdown && (
                  <div className={styles.recordSelectList}>
                    {[8, 16].map((n) => (
                      <span
                        key={n}
                        onClick={() => {
                          setProductsPerPage(n);
                          setShowRecordDropdown(false);
                        }}>
                        {n}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {useTwoSections ? (
            <>
              <div className={styles.categoryBlock}>
                {displayedProducts.slice(0, 8).map((product, index) => (
                  <ProductCard key={index} flexContainer product={product} containerStyle={styles.maxWidth} />
                ))}
              </div>
              <div className={styles.categoryBlock}>
                {displayedProducts.slice(8, 16).map((product, index) => (
                  <ProductCard key={index + 8} flexContainer product={product} containerStyle={styles.maxWidth} />
                ))}
              </div>
            </>
          ) : (
            <div className={styles.categoryBlock}>
              {displayedProducts.map((product, index) => (
                <ProductCard key={index} flexContainer product={product} containerStyle={styles.maxWidth} />
              ))}
            </div>
          )}
          {showMoreBtn && (
            <div>
              <Link to={url} className={styles.moreBtn}>
                {langData.buttons.view_all[currentLanguage]}
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CategoryBlock;
